module.exports = state => `
  <li><a href='./#articles/sheetify_document'>awoo document <mark>JANUARY 2, 2017</mark></a></li>
`